import "./FoundCard.css";
import { ProgressBar } from "../ProgressBar/ProgressBar";
export const FoundCard = ({
  qualifiedAbstracts,
  totalAbstracts,
  qualifiedOrgDocuments,
  totalOrgDocuments,
}) => {
  return (
    <div className="FoundCard">
      <div className="text">
        <span className="qualified">{qualifiedAbstracts}</span> abstracts
        qualified out of <span className="analyzed">{totalAbstracts}</span>{" "}
        analyzed
        <ProgressBar percent={(qualifiedAbstracts / totalAbstracts) * 100} />
      </div>
      {totalOrgDocuments > 0 && (
        <div className="text">
          <span className="qualified">{qualifiedOrgDocuments}</span> org
          documents qualified out of{" "}
          <span className="analyzed">{totalOrgDocuments}</span> relevant
          documents
          <ProgressBar
            percent={
              totalOrgDocuments > 0
                ? (qualifiedOrgDocuments / totalOrgDocuments) * 100
                : 0
            }
          />
        </div>
      )}
    </div>
  );
};
